import React from "react";
import { useQuill } from "react-quilljs";
import "quill/dist/quill.snow.css";

/**
 * Rich text editor component using Quill
 * FIXED: Cursor now appears anywhere you click in the editor area
 */
const TextEditor = ({ value, onChange }) => {
  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ["bold", "italic", "underline", "strike"],
      [{ list: "ordered" }, { list: "bullet" }],
      [{ indent: "-1" }, { indent: "+1" }],
      [{ color: [] }, { background: [] }],
      [{ align: [] }],
      ["link", "image", "video"],
      ["clean"],
    ],
  };

  const { quill, quillRef } = useQuill({ modules });

  React.useEffect(() => {
    if (quill) {
      quill.on("text-change", () => {
        onChange(quill.root.innerHTML);
      });
      if (value && quill.root.innerHTML !== value) {
        quill.root.innerHTML = value;
      }
    }
  }, [quill, onChange, value]);

  return (
    <div className="border border-gray-300 rounded-lg overflow-hidden">
      <div ref={quillRef} className="quill-editor-wrapper" />

      {/* Custom styles to make editor fill container and show cursor anywhere */}
      <style>{`
        /* Make the Quill container fill the space */
        .quill-editor-wrapper .ql-container {
          min-height: 300px;
          height: auto;
          font-size: 14px;
        }
        
        /* Make the editable area fill the container and show cursor */
        .quill-editor-wrapper .ql-editor {
          min-height: 300px;
          cursor: text;
          padding: 12px 15px;
        }
        
        /* Ensure the editor fills vertical space */
        .quill-editor-wrapper .ql-container.ql-snow {
          border: none;
        }
        
        /* Make toolbar border subtle */
        .quill-editor-wrapper .ql-toolbar.ql-snow {
          border: none;
          border-bottom: 1px solid #e5e7eb;
          background-color: #f9fafb;
        }
        
        /* Focus state */
        .quill-editor-wrapper .ql-editor:focus {
          outline: none;
        }
        
        /* Placeholder styling */
        .quill-editor-wrapper .ql-editor.ql-blank::before {
          color: #9ca3af;
          font-style: normal;
          content: 'Start typing your activity description...';
        }
      `}</style>
    </div>
  );
};

export default TextEditor;
